import store from 'store'
import {
    ERefreshTokenExpired,
    setIsAuthExpired,
} from 'store/actions/auth.action'

const authExpiredHandler = () => {
    store.dispatch(
        setIsAuthExpired(
            undefined,
            ERefreshTokenExpired.RefreshTokenExpired,
            false,
        ),
    )
}

export default authExpiredHandler
